import React, { FC, memo, useRef } from 'react'

import clsx from 'clsx'
import { useHoverDirty } from 'react-use'

import { Icon, Txt } from 'src/components/atoms'

export type NavigationType = 'dashboard' | 'project' | 'user' | 'setting' | 'mypage'

type Props = {
  isSelected: boolean
  navigationType: NavigationType | null
  className?: string
}

export const GlobalNavigationItem: FC<Props> = memo(({ isSelected, navigationType, className }) => {
  const ref = useRef(null)
  const isHovering = useHoverDirty(ref)

  const navigationText =
    navigationType === 'dashboard'
      ? 'ダッシュボード'
      : navigationType === 'project'
      ? 'プロジェクト'
      : navigationType === 'user'
      ? 'ユーザー'
      : navigationType === 'setting'
      ? '全権管理設定'
      : 'マイページ'

  const iconHref =
    navigationType === 'dashboard'
      ? isSelected
        ? 'two-tone-monitor-check/selected'
        : 'two-tone-monitor-check/default'
      : navigationType === 'project'
      ? isSelected
        ? 'two-tone-appearance/selected'
        : 'two-tone-appearance/default'
      : navigationType === 'user'
      ? isSelected
        ? 'two-tone-user/selected'
        : 'two-tone-user/default'
      : navigationType === 'setting'
      ? isSelected
        ? 'two-tone-gear/selected'
        : 'two-tone-gear/default'
      : isSelected
      ? 'two-tone-mypage/selected'
      : 'two-tone-mypage/default'

  return (
    <div className={className}>
      <button
        type="button"
        className={clsx(
          'tw-centering tw-rounded-[1.4rem] tw-w-[70px] tw-aspect-square',
          'tw-duration-150 tw-ease-in-out',
          isSelected
            ? 'tw-bg-roovPrimary-default'
            : 'tw-bg-surface-primary hover:tw-bg-surface-secondary tw-shadow-[0_0.14rem_1.71rem_rgba(122,137,160,0.25)] hover:tw-shadow-[0_0_1.07rem_rgba(122,137,160,0.35)]'
        )}
        ref={ref}
      >
        <div
          className={clsx(
            'tw-grid tw-gap-s-4 tw-place-items-center',
            isSelected ? 'tw-text-inlineText-primary' : 'tw-text-roovPrimary-default'
          )}
        >
          <Icon
            size="--r2"
            path={iconHref}
            basePath="works"
            className={clsx(
              !isSelected && isHovering && 'tw-duration-150 tw-ease-in-out tw-scale-110'
            )}
          />
          <Txt className="!tw-text-[8px] tw-font-bold">{navigationText}</Txt>
        </div>
      </button>
    </div>
  )
})
